import { TrendingDown, Rocket, Search, MapPinOff, BotMessageSquare, Gauge } from "lucide-react";

import { Rich } from "@/components/Rich";
import { withDefaults } from "@/lib/sections";

const P_ICONS = [Search, MapPinOff, TrendingDown];
const S_ICONS = [Rocket, BotMessageSquare, Gauge];

export default function ProblemSolution({ content }) {
  const c = withDefaults("problem", content);
  const problems = (c.problem_items || []).map((text, i) => ({ icon: P_ICONS[i % 3], text }));
  const solutions = (c.solution_items || []).map((text, i) => ({ icon: S_ICONS[i % 3], text }));

  return (
    <section
      id="problema-solucion"
      data-testid="section-problem-solution"
      className="relative py-20 sm:py-28 border-t border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          {/* Problem */}
          <div
            data-testid="problem-card"
            className="relative rounded-2xl border border-slate-800 bg-slate-900/40 p-8 sm:p-10"
          >
            <div className="font-mono text-xs text-slate-500 mb-3">
              {c.problem_eyebrow}
            </div>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">
              <Rich text={c.problem_title} />
            </h2>
            <p className="mt-4 text-slate-400 leading-relaxed">
              {c.problem_text}
            </p>

            <ul className="mt-8 space-y-4">
              {problems.map((p, i) => (
                <li
                  key={i}
                  data-testid={`problem-item-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-lg bg-red-500/10 text-red-400 border border-red-500/20">
                    <p.icon size={18} />
                  </span>
                  <span className="text-slate-300">{p.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solution */}
          <div
            data-testid="solution-card"
            className="relative rounded-2xl border border-sky-500/30 bg-gradient-to-br from-slate-900 to-slate-900/40 p-8 sm:p-10 overflow-hidden"
          >
            <div
              className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-sky-500/10 blur-3xl"
              aria-hidden
            />
            <div className="relative">
              <div className="font-mono text-xs text-sky-400 mb-3">
                {c.solution_eyebrow}
              </div>
              <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                <Rich text={c.solution_title} accent="text-sky-400 font-mono" />
              </h2>
              <p className="mt-4 text-slate-400 leading-relaxed">
                {c.solution_text}
              </p>

              <ul className="mt-8 space-y-4">
                {solutions.map((s, i) => (
                  <li
                    key={i}
                    data-testid={`solution-item-${i}`}
                    className="flex items-start gap-3"
                  >
                    <span className="mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-lg bg-orange-500/10 text-orange-400 border border-orange-500/20">
                      <s.icon size={18} />
                    </span>
                    <span className="text-slate-200">{s.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
